<template>
    <div v-if="userBidStatus" class="bid-status" :class="[userBidStatus.boxClass, userBidStatus.class]">

        <i class="mdi" :class="userBidStatus.icon"></i>

        <div class="flex-grow-1">
            <div class="font-weight-bold" :class="userBidStatus.class">
                {{ userBidStatus.title }}
            </div>

            <div v-if="userBidStatus.message" class="small mb-0" :class="userBidStatus.class">
                {{ userBidStatus.message }}
            </div>
        </div>

        <!-- Checkout / Sold -->
        <div v-if="product.time_left < 0" class="ml-auto">
            <router-link v-if="userWon && product.has_been_sold !== 1" class="btn btn-light text-success"
                :to="{ name: 'checkoutOrder', params: { id: product.user_best_bid?.id, type: 'bid' } }">
                {{ $t('page.checkout') }}
            </router-link>

            <button disabled v-else-if="userWon" class="offer-status offer-status-accepted">
                <i class="mdi mdi-check-circle"></i>
                {{ $t('sentence.sold') }}
            </button>
        </div>
    </div>

</template>

<script>

export default {
    name: "UserBidStatusComp",
    props: {
        product: Object,
    },
    computed: {
        userBidStatus() {
            const product=this.product;
            if (!product||product.sales_type!=='auction') return null;

            const bids=product.bids??[];
            if (!bids.length) return null;

            const userId=this.$store.state.user?.id;
            if (!userId) return null;

            const userHasBid=bids.some(b => b.user_id===userId);
            if (!userHasBid) return null;

            const isHighest=
                product.best_bid?.price===product.user_best_bid?.price;

            const ended=product.time_left<0;

            const lowestNonReached=
                ended&&
                isHighest&&
                product.lowest_price>product.price;

            /* 🔴 Reserve / lowest price not reached */
            if (lowestNonReached) {
                return {
                    state: 'RESERVE_NOT_MET',
                    icon: 'mdi-alert-circle',

                    title: this.$t('sentence.reserve_price_not_met'),
                    boxClass: 'border-left border-warning bg-warning',
                    class: 'text-light'
                };
            }

            /* 🟢 Auction ended — user won */
            if (ended&&isHighest) {
                return {
                    state: 'WON',
                    icon: 'mdi-check-circle',

                    title: this.$t('sentence.youWonTheAuction'),
                    message: '',
                    boxClass: 'border-left border-light bg-success',
                    class: 'text-light'
                };
            }

            /* 🔴 Auction ended — user lost */
            if (ended&&!isHighest) {
                return {
                    state: 'LOST',
                    icon: 'mdi-close-circle',
                    title: this.$t('sentence.youDidNotWinTheAuction'),
                    message: '',
                    boxClass: 'border-left border-light bg-danger',
                    class: 'text-light'
                };
            }

            /* 🟢 Currently winning */
            if (!ended&&isHighest) {
                return {
                    state: 'WINNING',
                    icon: 'mdi-check-circle',

                    title: this.$t('sentence.youHaveHighestBid'),
                    message: this.$t('auction.winningBidMessage'),
                    boxClass: 'border-left border-success bg-light',
                    class: 'text-success'
                };
            }

            /* 🟠 Outbid */
            return {
                state: 'OUTBID',
                icon: 'mdi-alert-circle',

                title: this.$t('sentence.yourBidOverridden'),
                message: this.$t('auction.outbidMessage'),
                boxClass: 'border-left border-warning bg-light',
                class: 'text-warning'
            };
        }
        ,

        userWon() {
            return this.userBidStatus?.state==='WON';
        }
    }
}

</script>

<style scoped>
.bid-status {
    margin-top: 10px;
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border-left-width: 4px !important;
    border-radius: 6px;
    gap: .5rem;
    overflow: hidden;
    animation: slideInAlert-42e955ca 0.4s ease-out;
}
.bid-status div div{
    font-size: 9pt;
    line-height: 1rem;
    
}
</style>